import { ChangeDetectionStrategy, Component } from '@angular/core';
import { combineLatest, map } from 'rxjs';

import { AgentConfigFacade, ProfileFacade } from '@contact/upgrade';

@Component({
  selector: 'cng-agent-view-info-panel',
  templateUrl: 'agent-view-info-panel.component.html',
  styleUrls: ['./agent-view-info-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentViewInfoPanelComponent {
  readonly Infinity = Infinity;

  // display agent name
  readonly agent$ = combineLatest(this.profileFacade.firstname$, this.profileFacade.lastname$).pipe(
    map(([firstname, lastname]) => `${firstname} ${lastname}`)
  );
  // display teams
  readonly teams$ = this.agentConfigFacade.team$.pipe(map(team => team && [team.name]));
  // display groups
  readonly groups$ = this.agentConfigFacade.groups$.pipe(map(groups => groups && groups.map(({ name }) => name)));
  // display supervisors
  readonly supervisors$ = this.agentConfigFacade.supervisors$.pipe(
    map(supervisors => supervisors && supervisors.map(({ firstname, lastname }) => `${firstname} ${lastname}`))
  );

  constructor(private readonly profileFacade: ProfileFacade, private readonly agentConfigFacade: AgentConfigFacade) {}
}
